module.exports = __webpack_public_path__ + "static/media/icon-send.d9f34237.svg";